import React from 'react'
import Header from '../HeaderTwo/Main'
import PageHeader from '../MainLoans/PageHeader'
import ServiceDetails from '../MainLoans/ServiceDetails'
// import Header4 from '../HeaderFour/Main.js'
function Main() {
  return (
    <>
      <Header/>
      {/* <Header4/> */}
      <PageHeader/>
      <ServiceDetails/>
    </>
  )
}

export default Main
